import { ReactElement, ReactNode } from 'react';

import styles from './PageHeader.module.scss';

interface IProps {
  title: ReactNode;
  children?: ReactNode;
}

const PageHeader = ({ title, children }: IProps): ReactElement => (
  <div className={styles.container}>
    <div className={styles.title}>{title}</div>
    {children && <div className={styles.actions}>{children}</div>}
  </div>
);

export default PageHeader;
